import "./BannerController.css";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchMessages } from "shared/actions/messagesActions";

import ApplicationState from "store/ApplicationState";

import Banner from "./Banner";

const BannerController = () => {
  const dispatch = useDispatch();
  const messages = useSelector(({ sys }: ApplicationState) => sys.messages);

  useEffect(() => {
    dispatch(fetchMessages("viewer"));
  }, []);

  return messages ? (
    <div className="BannerController">
      {messages.map((m, i) => (
        <Banner type={m.type} key={i}>
          <>
            <strong>{m.title}:</strong> {m.message}
          </>
        </Banner>
      ))}
    </div>
  ) : null;
};

export default BannerController;
